import { environment } from "src/environments/environment";
export class ApiConfig {
    public static API_ENDPOINT: string = environment.apiUrl;
}